import script from "./TrainingView.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingView.vue?vue&type=script&setup=true&lang=js"

import "./TrainingView.vue?vue&type=style&index=0&id=bf08fb50&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf08fb50"]])

export default __exports__